import React from "react";
import { BaseComponent } from "../baseComponent/BaseComponent"

export class OpenAuctionWithApplications extends BaseComponent {
    constructor(props) {
        super(props);
    }

    detailsMenu() {
        return (
            <div className="lotDetails">
                <button
                    onClick={() => this.setState({ ...this.state, ActiveMenu: "Documents" })}
                    className={this.state.ActiveMenu === "Documents" && "active"}
                >Документы</button>
                <button
                    onClick={() => this.setState({ ...this.state, ActiveMenu: "Bets" })}
                    className={this.state.ActiveMenu === "Bets" && "active"}
                >Ставки({this.state.Lot?.Bets?.length > 0 ? this.state.Lot?.Bets?.length : 0})</button>
                <button
                    onClick={() => this.setState({ ...this.state, ActiveMenu: "Applications" })}
                    className={this.state.ActiveMenu === "Applications" && "active"}
                >Заявки({this.state.Lot.Applications?.length > 0 ? this.state.Lot.Applications?.length : 0})</button>
                <button
                    onClick={() => this.setState({ ...this.state, ActiveMenu: "LotDetails" })}
                    className={this.state.ActiveMenu === "LotDetails" && "active"}
                >Детали</button>
            </div>
        )
    }

    Details() {
        return (
            <>
                <div className="aboutTrade detailsWrapper">
                    <div className="tradeInfo">
                        <div className="infoItem">
                            <span className="defaultDataName">Вид торгов:</span>
                            <p className="defaultDataValue">{this.state.Lot.TradeTypeDescription}</p>
                        </div>

                        <div className="infoItem">
                            <span className="defaultDataName">Статус:</span>
                            <p className="defaultDataValue">{this.state.Lot.LotTradeStatusDescription}</p>
                        </div>

                        <div className="infoItem">
                            <span className="defaultDataName">Начало приема заявок:</span>
                            <p className="defaultDataValue">
                                {this.GetDate(this.state.Lot.LotApplicationPeriodStart)}
                            </p>
                        </div>

                        <div className="infoItem">
                            <span className="defaultDataName">Окончание приема заявок:</span>
                            <p className="defaultDataValue">
                                {this.GetDate(this.state.Lot.LotApplicationPeriodEnd)}
                            </p>
                        </div>

                        {this.state.Lot.LotTradePeriodStart &&
                            <div className="infoItem">
                                <span className="defaultDataName">Начало аукциона:</span>
                                <p className="defaultDataValue">
                                    {this.GetDate(this.state.Lot.LotTradePeriodStart)}
                                </p>
                            </div>
                        }
                    </div>
                </div>
            </>
        )
    }

    renderTradeHint() {
        return (
            <div>
                <img style={{ height: "40px" }} src="../../../../../../main-images/needCert.jpg" />
            </div>
        );
    }

    renderIsDeposit() {
        return <span><br /><b>c задатком</b></span>
    }

    render() {
        return (
            <React.Fragment>
                {this.ShortInfoLot()}
            </React.Fragment>
        )
    }
}